module.exports = __webpack_public_path__ + "components/rewards/armadillo/static/icon-47b4c2a6ec2eb616be802a34d840f27c.svg";